import { render } from "./Instructions.vue?vue&type=template&id=e0fbb2b6&scoped=true"
import script from "./Instructions.vue?vue&type=script&lang=js"
export * from "./Instructions.vue?vue&type=script&lang=js"

import "./Instructions.vue?vue&type=style&index=0&id=e0fbb2b6&scoped=true&lang=css"

import exportComponent from "/home/time/IdeaProjects/mektep-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0fbb2b6"]])

export default __exports__